module.exports = __webpack_public_path__ + "img/img0.f8a30895.jpg";